export default __webpack_public_path__ + "static/media/admin-gestao-usuarios.343a1a45.svg";